export interface TimeSpan {
  minutes?: number,
  hours?: number,
  days?: number,
  weeks?: number,
  months?: number,
  years?: number
};

export const getDateIn = (opts: TimeSpan = {}, date?: Date) => {

  const {
    days,
    hours,
    minutes,
    weeks,
    months,
    years
  } = opts;

  const r = new Date(date || Date.now());

  if (!!minutes) {
    r.setMinutes(r.getMinutes() + minutes);
  }

  if (!!hours) {
    r.setHours(r.getHours() + hours);
  }

  if (!!days) {
    r.setDate(r.getDate() + days);
  }

  if (!!weeks) {
    r.setDate(r.getDate() + (weeks * 7));
  }

  if (!!months) {
    r.setMonth(r.getMonth() + months);
  }

  if (!!years) {
    r.setFullYear(r.getFullYear() + years);
  }

  return r;
}